/* Excelsa theme — global JS
   Handles: active nav state, product option swatches, subscribe/one-time toggle,
   qty steppers, newsletter form, simple cart quantity updates. */

(function () {
  // Active nav
  const page = document.body.dataset.page;
  if (page) document.querySelectorAll('[data-page="' + page + '"]').forEach(a => a.classList.add('active'));

  // Option buttons (variants)
  document.querySelectorAll('.pdp-opts').forEach(group => {
    group.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      group.querySelectorAll('button').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      const hidden = document.querySelector('[data-hidden-' + group.dataset.opts + ']');
      if (hidden) hidden.value = b.dataset.value || b.textContent.trim();
    });
  });
  // Subscribe toggle
  document.querySelectorAll('.pdp-sub-toggle').forEach(group => {
    group.addEventListener('click', e => {
      const l = e.target.closest('label'); if (!l) return;
      group.querySelectorAll('label').forEach(x => x.classList.remove('on'));
      l.classList.add('on');
    });
  });
  // Qty steppers
  document.querySelectorAll('.pdp-qty, .cart-qty').forEach(q => {
    const span = q.querySelector('span'), input = q.querySelector('input');
    q.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      const cur = parseInt((span || input).textContent || input.value || '1', 10);
      const next = Math.max(1, b.textContent.includes('+') ? cur + 1 : cur - 1);
      if (span) span.textContent = next;
      if (input) input.value = next;
      if (q.dataset.updatesCart) q.form && q.form.submit();
    });
  });


  // ── PDP Gallery — thumbnail → main image swap ───────────────────────────
  document.querySelectorAll('.pdp-thumbs').forEach(function (thumbs) {
    var mainImg = thumbs.closest('.pdp-gallery').querySelector('.pdp-main img');
    if (!mainImg) return;

    thumbs.querySelectorAll('button[data-src]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Swap main image
        mainImg.src = btn.dataset.src;

        // Update active state
        thumbs.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
      });
    });
  });

})();
